const heroMain = {
  title: 'PEGASUS ARMS 25',
  description: 'This is a solution for those who require precision, autonomy and reliability in actual combat. Its primary mission on the front is to reach the target, destroy it, return, and preserve lives of Ukraine’s defenders.',
  buttons: {
    learnMore: 'Learn more',
  },
}

export default heroMain
